import React, { useState} from "react";
import { generateHeader } from "../../utils/paso2.utils";
import { SUCURSALES, CURSOS_INGLES, INICIALES, COLORES } from "../../utils/constants";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const CardCursoTraslado = ({ data, state, handleClick, textoBoton, id, value, setCursos, send, contador, setContador }) => {

    const [indiceXSubmenu, setIndiceXSubmenu] = useState(0);
    const [indiceYSubmenu, setIndiceYSubmenu] = useState(0);
    const [nombreSede, setNombreSede] = useState(state.context.nombreSede)

    const [actions, setActions] = useState(
        [
            {
                id: '1',
                title: 'Enero',
                selected: false,
            },
            {
                id: '2',
                title: 'Febrero',
                selected: false,
            },
            {
                id: '3',
                title: 'Marzo',
                selected: false,
            },
            {
                id: '4',
                title: 'Abril',
                selected: false,
            },
            {
                id: '5',
                title: 'Mayo',
                selected: false,
            },
            {
                id: '6',
                title: 'Junio',
                selected: false,
            },
            {
                id: '7',
                title: 'Julio',
                selected: false,
            },
            {
                id: '8',
                title: 'Agosto',
                selected: false,
            },
            {
                id: '9',
                title: 'Septiembre',
                selected: false,
            },
            {
                id: '10',
                title: 'Octubre',
                selected: false,
            },
            {
                id: '11',
                title: 'Noviembre',
                selected: false,
            },
            {
                id: '12',
                title: 'Diciembre',
                selected: false,
            },
        ]
    )

    //console.log('data traslado', data)
    const generateKey = () => {
        // return Math.random().toString(30).substring(2);
        setContador(() => contador + 1)
        return contador
    }



    const handleCupon = (curso) => {
        if (!curso?.precioAnterior) {
            let copiaCurso = curso;
            const descuento = curso.Cupones.reduce((total, cupon) =>
                total + cupon.ValorCupon
                , 0)
            const precioAnterior = copiaCurso.Valor
            copiaCurso.Valor = (precioAnterior - descuento)
            copiaCurso.precioAnterior = precioAnterior
            return copiaCurso
        }
    }


    const handleCheck = (e, el, index, element, idx, indexp) => {
        const CargosPagar = element.Cargos.filter(cargo => cargo.Cargo !== el.Cargo)
        CargosPagar.forEach(element => {
            element.Pagar = 1
        });
        const dataCopy = [...data]
        const sortIndex = generateKey()
        let key = dataCopy[idx]["Horarios"][indexp]["IdHorario"]

        // si true incremento, else , decremento (que tome del actual a los proximos)
        const header = generateHeader(dataCopy, idx, key)

        if (e.target.checked) {
            for (let ix = 0; ix <= element.Cargos.length - 1; ix++) {

                if (ix === 0) {
                    dataCopy[idx]["Horarios"][indexp]["Cargos"][ix]["Header"] = header  // al tenerlo en seleccionados, no se pueden adjuntar, por tenerlos ya, agarralos desde la api
                    dataCopy[idx]["Horarios"][indexp]["Cargos"][ix]["Header"]["IdSede"] = state.context.sede // segun la sede que tenga en el momento se va al header
                }
                dataCopy[idx]["Horarios"][indexp]["Cargos"][ix]["Key"] = key
                dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].IndexCurso = idx
                dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].IndexHorario = indexp
                dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].IndexCargo = index
                dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].IdHorario = key
                dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].sortIndex = sortIndex
                dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].IdSede = state.context.sede
                dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].Pagar = 0
                console.log('DATO:  ', handleCupon(dataCopy[idx]["Horarios"][indexp]["Cargos"][ix]))
                if (ix > index) {
                    dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].Pagar = 1
                    dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].Seleccionado = false //e.target.checked
                } else {
                    dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].Pagar = 0
                    dataCopy[idx]["Horarios"][indexp]["Cargos"][ix].Seleccionado = true //e.target.checked
                }
                send("SELECCIONAR", { seleccionado: dataCopy[idx]["Horarios"][indexp]["Cargos"][ix] })
            }
            setCursos(() => dataCopy)
        } else {
            const cargosLength = dataCopy[idx]["Horarios"][indexp]["Cargos"].length
            // usar some para ver si el padre o alguno de sus padres está Pagado: 0  REVISAR
            if (dataCopy[idx]["Horarios"][indexp]["Cargos"].some(cargo => cargo.Pagar === 0)) {
                // si hay un cargo Pagado, no se puede quitar de seleccionados
                return
            } else {

                for (index; index < cargosLength; index++) {
                    try {
                        dataCopy[idx]["Horarios"][indexp]["Cargos"][index].Seleccionado = false // e.target.checked
                        dataCopy[idx]["Horarios"][indexp]["Cargos"][index].Pagar = 1 // e.target.checked
                    } catch (error) {
                    }
                    send("QUITAR_DE_RESUMEN", { seleccionado: dataCopy[idx]["Horarios"][indexp]["Cargos"][index] })
                }
            }
            setCursos(() => dataCopy)
        }
    }

    const handleCambio = (dato, opcion) => {
        send("GUARDAR_OPCION_TRASLADO", { opcion: opcion });
        if (opcion === 3) {
            send('RESET_CURSOS_ANTES', { reset: [] })
            const arr = state.context.seleccionados[0].Cursos.filter((e) => e.IdCurso === dato.IdCurso )
            send('ACTUALIZAR_SELECCIONADOS', { seleccionados: arr })
            send('GUARDAR_CURSOS_ANTES', { CursosAntes: arr })
        } else {
            send('RESET_CURSOS_ANTES', { reset: [] })
            const arr = state.context.seleccionados[0].Cursos.filter((e) => e.IdCurso === dato.IdCurso)
            send('ACTUALIZAR_SELECCIONADOS', { seleccionados: arr })
            send('GUARDAR_CURSOS_ANTES', { CursosAntes: arr })
        }

        if (opcion === 1) {
            send("GUARDAR_IDCURSOD", { idCursoD: dato });
        }

        if (opcion === 2) {
            send("GUARDAR_IDCURSOD", { idCursoD: [] });
        }

        if (opcion === 3) {
            send("GUARDAR_IDCURSOD", { idCursoD: dato });
        }
    };

    return (
        <div className=" flex justify-center">
            <div className={"bg-primarioMira rounded-md p-1 m-2 content-center w-full"}>
                <div className={"||flex ||content-center text-center"}>
                    <p className={"text-white ||mx-auto font-medium text-2xl mt-2"}>
                        {`Cursos asignados`}
                    </p>
                    <p className="text-secundario">Selecciona el curso y la acción que deseas realizar.</p>
                </div>
                {data?.length > 0 ? (
                    <div
                        role="list"
                        className="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-2 xl:grid-cols-4 mx-3 mb-4 "
                    >
                        {data?.map((project, idx) =>
                            <div className="max-w-sm p-2 border border-gray-200 bg-secundarioMira rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 /grid">
                                {project?.IdCurso > 9 && project?.IdCurso < 23 ?
                                    <div className="text-center m-1 p-2">
                                        <p className={`/inline text-white bg-${CURSOS_INGLES[project?.IdCurso]['color']} m-auto rounded-full w-30 h-30 ring-1 ring-white text-5xl`}>
                                            {CURSOS_INGLES[project?.IdCurso]['inicial']}
                                        </p>
                                    </div>
                                    :
                                    <img
                                    width="96"
                                    height="96"
                                    src={(`./img/cursos/${project?.Imagen}`)}
                                    onError={({ currentTarget }) => {
                                      currentTarget.onerror = null; // prevents looping
                                      currentTarget.src='./img/cursos/defaultImage.jpg';
                                    }}
                                    className="/h-12 /w-12 mx-auto">
                                  </img>
                                }
                                <a href="#" className="mx-auto inline text-center">
                                    <p className="mb-2 text-xl font-medium tracking-tight text-white dark:text-white ">
                                        {project?.[value]}
                                    </p>
                                </a>
                                <p className={`font-normal inline text-${COLORES[project?.IdSede]}`}>{`${INICIALES[project?.IdSede]} - ${SUCURSALES[project?.IdSede]}`}</p>
                                <p className="font-normal text-green-500" >{project?.Dias}</p>
                                <p className="font-normal text-secundario">{project?.Modalidad === 1 ? 'Modalidad Online' : 'Modalidad Presencial'}</p>
                                {project?.DuraMes === 1
                                    ? <p className="font-normal text-grisMira">{`Duración del curso ${project?.DuraMes} mes`}</p>
                                    : <p className="font-normal text-grisMira">{`Duración del curso ${project?.DuraMes} meses`}</p>
                                }
                                <p className="font-normal text-grisMira">{`Inicio del curso ${actions[parseInt(project?.IdPeriodo.substring(0, 2))].title} / 2025`}</p>
                                <div className="||shadow-azulBrillanteMira shadow-sm rounded-md  my-2">
                                    <div className="flex flex-row w-full bg-azulBrillanteMira rounded-t-md rounded-b-md">
                                        <div className="flex justify-between w-full text-white bg-azulBrillanteMira font-medium rounded-lg text-sm px-4 py-1 text-center items-center">
                                            <div className="flex flex-col justify-items-start">
                                                <span className="flex">{project?.NombrePlan}</span>
                                                <span className="flex text-xs">
                                                    {project?.DescripcionPlan}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col">
                                        <button
                                            className="mt-4 inline py-1.5 px-1 xl:px-2 text-sm font-medium text-center text-white bg-azulBrillanteMira rounded-lg hover:bg-secundario hover:shadow-white shadow-sm"
                                            onClick={() => handleCambio(project, 1)}
                                        >
                                            Cambio de horario
                                        </button>

                                        <button
                                            className="mt-4 inline py-1.5 px-1 xl:px-2 text-sm font-medium text-center text-white bg-azulBrillanteMira rounded-lg hover:bg-secundario hover:shadow-white shadow-sm"
                                            onClick={() => handleCambio(project, 2)}
                                        >
                                            Traslado de fondos
                                        </button>

                                        <button
                                            className="mt-4 inline py-1.5 px-1 xl:px-2 text-sm font-medium text-center text-white bg-azulBrillanteMira rounded-lg hover:bg-secundario hover:shadow-white shadow-sm"
                                            onClick={() => handleCambio(project, 3)}
                                        >
                                            Devolución
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="text-2xl text-secundario flex w-full">
                        <p className="flex m-auto">No se encontraron cursos disponibles</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CardCursoTraslado;
